import { createAction, props } from '@ngrx/store';
import { ISharedContentParams, ISharedFolderContentResponse, IUnreadResponse } from '../../models';

export const GetSharedContent = createAction(
  '[Shared Content] Get Shared Content',
  props<{ params: ISharedContentParams; forced?: boolean }>()
);
export const GetSharedContentSuccess = createAction(
  '[Shared Content] Get Shared Content Success',
  props<{ response: ISharedFolderContentResponse }>()
);
export const GetSharedContentFailed = createAction(
  '[Shared Content] Get Shared Content Failed',
  props<{ error: Error }>()
);

export const GetUnread = createAction('[Shared Content] Get Unread');
export const GetUnreadSuccess = createAction(
  '[Shared Content] Get Unread Success',
  props<{ response: IUnreadResponse }>()
);
export const GetUnreadFailed = createAction(
  '[Shared Content] Get Unread Failed',
  props<{ error: Error }>()
);

export const StartPollUnread = createAction('[Shared Content] Start Poll Unread');
export const StopPollUnread = createAction('[Shared Content] Stop Poll Unread');

export const MigrateDocuments = createAction(
  '[Shared Content] Migrate Documents',
  props<{ markAsRead: boolean }>()
);
export const MigrateDocumentsSuccess = createAction('[Shared Content] Migrate Documents Success');
export const MigrateDocumentsFailed = createAction(
  '[Shared Content] Migrate Documents Failed',
  props<{ error: Error }>()
);
